export enum Type {
  ADD_TODO    = 'ADD_TODO',
  DONE_TODO   = 'DONE_TODO',
  DELETE_TODO = 'DELETE_TODO',
  PUT_TODO    = 'PUT_TODO',
  INIT_TODO   = 'INIT_TODO',
}